module.exports = __webpack_public_path__ + "images/kick-off-holder-d0719c2b918e420da2254dd85dee6adb.svg";